<script>
import BaseCard from "./BaseCard.vue";
import BaseContent from "./BaseContent.vue";
import CharacterStat from "./CharacterStat.vue";

export default {
    name: "CharacterEzaPotential",
    components: { BaseContent, CharacterStat, BaseCard },
    props: {
        character: {
            type: Object,
            required: true,
        },
        potentialUnlocked: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        calculateStat(stat) {
            return (
                this.character[stat].eza +
                (this.potentialUnlocked
                    ? this.character.hidden_potential[stat]
                    : 0)
            );
        },
    },
    computed: {
        hp() {
            return this.calculateStat("hp");
        },
        atk() {
            return this.calculateStat("atk");
        },
        def() {
            return this.calculateStat("def");
        },
    },
};
</script>

<template>
    <BaseCard class="!p-0">
        <template #heading>EZA Potential</template>
        <BaseContent>
            <div class="grid grid-cols-3 items-start justify-between gap-4 p-4">
                <span class="col-span-3 text-sm font-light italic text-red-300"
                    >This character does not currently possess an Extreme
                    Z-Awakening; these stats are indicative.</span
                >
                <CharacterStat :value="hp" type="HP" />
                <CharacterStat :value="atk" type="ATK" />
                <CharacterStat :value="def" type="DEF" />
            </div>
        </BaseContent>
    </BaseCard>
</template>

<style scoped></style>
